const mapValueToRange = (
    inputValue: number,
    inputMin: number,
    inputMax: number,
    outputMin: number,
    outputMax: number
) => {
    const inputRange = inputMax - inputMin
    const outputRange = outputMax - outputMin
    const relativeValue = (inputValue - inputMin) / inputRange
    return relativeValue * outputRange + outputMin
}

export const translateRatingToDecimal = (
    inputValue: number | undefined,
    getNumber = false
): any => {
    if (inputValue == undefined) return

    const result = mapValueToRange(inputValue, 0, 100, 0, 5)

    const formatted = Number(result.toFixed(2)) // siempre limitar a 2 decimales

    return getNumber ? formatted : formatted.toString()
}
